import { createContext, useMemo, useContext, useState } from 'react';
import PropTypes from 'prop-types';

const WorkspaceCreationContext = createContext({});

export const WorkspaceCreationProvider = ({ children }) => {
  // states
  const [workspaceId, setWorkspaceId] = useState();
  const [workspaceProfileId, setWorkspaceProfileId] = useState();
  const [projectId, setProjectId] = useState('');
  const [workspaceName, setWorkspaceName] = useState('');
  const [workspaceLogo, setWorkspaceLogo] = useState({ blob: undefined, dataURI: undefined, file: undefined });
  const [workspaceHandle, setWorkspaceHandle] = useState('');
  const [workspaceProfileName, setWorkspaceProfileName] = useState('');
  const [workspaceProfileLogo, setWorkspaceProfileLogo] = useState({ blob: undefined, dataURI: undefined, file: undefined });
  const [projectName, setProjectName] = useState('');
  const [projectKey, setProjectKey] = useState('');
  const [projectDescription, setProjectDescription] = useState('');
  const [errors, setErrors] = useState({});

  const addError = (key, value) => {
    setErrors((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const removeError = (key) => {
    setErrors((prev) => {
      const newErrors = { ...prev };
      delete newErrors[key];
      return newErrors;
    });
  };

  const clearForm = () => {
    setWorkspaceName('');
    setWorkspaceLogo({});
    setWorkspaceHandle('');
    setWorkspaceProfileName('');
    setWorkspaceProfileLogo({});
    setProjectName('');
    setProjectKey('');
    setProjectDescription('');
    setWorkspaceId('');
    setWorkspaceProfileId('');
    setProjectId('');
    setErrors({});
  };

  const values = useMemo(() => ({
    workspaceName,
    workspaceLogo,
    workspaceHandle,
    workspaceProfileName,
    workspaceProfileLogo,
    projectName,
    projectKey,
    projectDescription,
    workspaceId,
    workspaceProfileId,
    projectId,
    setWorkspaceName,
    setWorkspaceLogo,
    setWorkspaceHandle,
    setWorkspaceProfileName,
    setWorkspaceProfileLogo,
    setProjectName,
    setProjectKey,
    setProjectDescription,
    setWorkspaceId,
    setWorkspaceProfileId,
    setProjectId,
    errors,
    addError,
    removeError,
    clearForm,
  }));

  return (
    <WorkspaceCreationContext.Provider value={values}>
      {children}
    </WorkspaceCreationContext.Provider>
  );
};

const useWorkspaceCreation = () => {
  const context = useContext(WorkspaceCreationContext);
  if (context === undefined) {
    throw new Error('useWorkspaceCreation must be used within a WorkspaceCreationProvider');
  }
  return context;
};

WorkspaceCreationProvider.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
};

export default useWorkspaceCreation;
